import { render, staticRenderFns } from "./MailClientList.vue?vue&type=template&id=6e91c3c7&scoped=true"
import script from "./MailClientList.vue?vue&type=script&lang=js"
export * from "./MailClientList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e91c3c7",
  null
  
)

export default component.exports